import KeyCloackService from '../../services/KeyCloackService';

type Props = {
    children: JSX.Element;
}

const RenderOnAnonymous = ({ children }:Props) => (!KeyCloackService.isLoggedIn()) ? children : null;

export default RenderOnAnonymous